<template>
  <v-app id="FooterItem">
    <!-- モバイルデバイス用 -->
    <v-footer
      v-if="mobileFlg"
      app
      class="pa-2"
      elevation="5"
      color="grey lighten-3"
      style="color:#3F51B5; font-size:11px"
    >
      <a
        href="http://r4support.epson.jp/r4support/ManualDL.nsf/Kmanual/M9000107"
        target="_blank"
        rel="noopener"
      >マニュアル</a>｜
      <a
        href="https://www.epson.jp/products/ac/support/tel.htm"
        target="_blank"
        rel="noopener"
      >お問い合わせ</a>｜
      <a
        href="https://www.epson.jp/products/ac/privacy_statement/weplat.htm"
        target="_blank"
        rel="noopener"
      >プライバシーステートメント</a>｜
      <a
        href="https://weplat.epson.jp/ac/datashare/etc/about_weplat.htm"
        target="_blank"
        rel="noopener"
      >利用規約</a>｜
      <a
        href="/license"
        target="_blank"
        rel="noopener"
      >LICENSE</a>
      <v-spacer />
      <span style="color:#3F51B5; font-size:10px">© Seiko Epson Corp. / Epson Sales Japan Corp. 2020</span>
    </v-footer>
    <!-- PC用 -->
    <v-footer
      v-else
      app
      elevation="5"
      color="grey lighten-3"
      style="color:#3F51B5; font-size:16px"
    >
      <a
        href="http://r4support.epson.jp/r4support/ManualDL.nsf/Kmanual/M9000107"
        target="_blank"
        rel="noopener"
      >マニュアル</a>｜
      <a
        href="https://www.epson.jp/products/ac/support/tel.htm"
        target="_blank"
        rel="noopener"
      >お問い合わせ</a>｜
      <a
        href="https://www.epson.jp/products/ac/privacy_statement/weplat.htm"
        target="_blank"
        rel="noopener"
      >プライバシーステートメント</a>｜
      <a
        href="https://weplat.epson.jp/ac/datashare/etc/about_weplat.htm"
        target="_blank"
        rel="noopener"
      >利用規約</a>｜
      <a
        href="/license"
        target="_blank"
        rel="noopener"
      >LICENSE</a>
      <v-spacer />
      <span style="color:#3F51B5; font-size:14px">© Seiko Epson Corp. / Epson Sales Japan Corp. 2020</span>
    </v-footer>
  </v-app>
</template>

<script>
import {isMobile} from '../amplify_com.js';

export default {
  data: () => ({
    mobileFlg: isMobile.any,
  }),
};
</script>

<style scoped>
a{
  color:#3F51B5 !important;
}
</style>